<div class="fx-modal-container" ngDraggable>
	<div class="fx-modal-title">
		<div dw-row>
			<i class="anticon anticon-user"></i>
			<span>{{'角色用户范围设置 - ' + role_id + '(' + role_name + ')' }}</span>
		</div>
	</div>
	<div class="fx-modal-content" style="overflow-y: hidden;">
		<div dw-row style="height: 500px;" dwGutter="8">
			<div dw-col dwSpan="7">
				<dw-input-group [dwSuffix]="suffixIcon">
					<input type="text" dw-input placeholder="搜索" [(ngModel)]="searchValue">
				</dw-input-group>
				<ng-template #suffixIcon>
					<i class="anticon anticon-search"></i>
				</ng-template>
				<div class="my-tree">
					<dw-tree
              #treeCom
							[dwData]="nodes"
							[dwSearchValue]="searchValue"
							[dwDefaultExpandAll]="true"
							(dwClick)="dwClick($event)"
					>
					</dw-tree>
				</div>

			</div>
			<div dw-col dwSpan="8">
				<dw-form-item>
					<dw-form-label [dwSm]="6" [dwXs]="24" dwFor="org-user-search">待选择用户</dw-form-label>
					<dw-form-control [dwSm]="14" [dwXs]="24">
						<input dw-input type="text" id="org-user-search" placeholder="搜索" [(ngModel)]="orgUserSearchValue" (ngModelChange)="searchOrgUser()">
					</dw-form-control>
				</dw-form-item>
				<ag-grid-angular
            #agGrid1
						style='height: 450px;'
						id="myGrid1"
						[rowData]="filteredOrgUsers"
						class="ag-theme-balham"
						[defaultColDef]="defaultColDef"
						[columnDefs]="columnDefs1"
						[context]="gridContext1"
						[enableSorting]="true"
						[enableFilter]="true"
						[floatingFilter]="false"
						[enableColResize]="true"
						[suppressRowClickSelection]="true"
						[suppressCellSelection]="true"
						(gridReady)="onGrid1Ready($event)"
						[rowSelection]="'multiple'"
						[localeTextFunc]="localTextFunc"
				></ag-grid-angular>
			</div>
			<div dw-col dwSpan="1" class="toolbar">
				<div div-row><button dw-button dwType="default" [dwSize]="'small'" (click)="addSelectedItem()"> ></button></div>
				<div div-row><button dw-button dwType="default" [dwSize]="'small'" (click)="removeSelectedItem()"> <</button></div>
			</div>
			<div dw-col dwSpan="8">
				<dw-form-item>
					<dw-form-label [dwSm]="6" [dwXs]="24" dwFor="selected-user-search">已选择用户</dw-form-label>
					<dw-form-control [dwSm]="14" [dwXs]="24">
						<input dw-input type="text" id="selected-user-search" placeholder="搜索" [(ngModel)]="selectedUserSearchValue" (ngModelChange)="searchSelectedUser()">
					</dw-form-control>
				</dw-form-item>
				<ag-grid-angular
            #agGrid2
						style='height: 450px;'
						id="myGrid2"
						[rowData]="filteredSelectedUsers"
						class="ag-theme-balham"
						[defaultColDef]="defaultColDef"
						[columnDefs]="columnDefs2"
						[context]="gridContext2"
						[enableSorting]="true"
						[enableFilter]="true"
						[floatingFilter]="false"
						[enableColResize]="true"
						[suppressRowClickSelection]="true"
						[suppressCellSelection]="true"
						(gridReady)="onGrid2Ready($event)"
						[rowSelection]="'multiple'"
						[localeTextFunc]="localTextFunc"
				></ag-grid-angular>
			</div>
		</div>

	</div>
	<div class="fx-modal-footer">
		<div dw-row dwType="flex" dwJustify="end" style="padding-right: 16px;">
			<div dw-col>
				<button dw-button [dwType]="'primary'" (click)="onClickContinue()" *ngIf="!isRemind">确定</button>
			</div>
		</div>
	</div>
</div>
